export { PrintedStatement } from './printed-statement.page';
